<card>
    <div class="card-header-content">
        <h1>
            {{wording.journeySearch}}
            <btn type="actionHeaderLink" (onClick)="toggleDescription()">
                <i class="fa fa-question-circle icon"></i>
            </btn>

            <div *ngIf="showDescription" class="field-description">
                <field-description [description]="formDescription"
                                   (clickOutside)="toggleDescription()"></field-description>
            </div>
        </h1>

        <div>
            <ng-container *ngIf="!contextIsModifySegment">
                <btn type="actionHeaderLink"
                     (onClick)="reset()"
                     [label]="wording.newSearch"
                     *permissionIf="'iqba.searchForm.reset'"></btn>
            </ng-container>
            <ng-container *ngIf="config.segment.direction != 'Oneway'">
                <btn type="actionHeaderLink"
                     [label]="wording.oneWay"
                     (onClick)="changeSegment('Oneway')"
                     *permissionIf="'iqba.searchForm.sector'"></btn>
            </ng-container>
            <ng-container *ngIf="config.segment.direction != 'Return'">
                <btn type="actionHeaderLink"
                     [label]="wording.return"
                     (onClick)="changeSegment('Return')"
                     *permissionIf="'iqba.searchForm.sector'"></btn>
            </ng-container>

            <ng-container *ngIf="config.segment.direction != 'Multiple'">
                <btn type="actionHeaderLink"
                     [label]="wording.multiple"
                     (onClick)="changeSegment('Multiple')"
                     *permissionIf="'iqba.searchForm.sector'"></btn>
            </ng-container>

            <btn type="actionUndo"
                 *ngIf="isFromWatabi"
                 (onClick)="returnToWTB()"
                 [label]="wording.backToWTB"></btn>

            <btn type="actionUndo"
                 *ngIf="canClose"
                 (onClick)="emitClose()"
                 [label]="wording.close"></btn>

        </div>
    </div>

    <div class="card-body-content card-marge-inside">
        <searchAirTripForm [config]="config" [searchData]="searchData" [readonlyParams]="contextIsModifySegment" [isFromWatabi]="isFromWatabi"></searchAirTripForm>
    </div>
</card>